module.exports = __webpack_public_path__ + "static/media/wou_logo.3175a49b.svg";